import * as React from 'react';
import { EditFilled } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import ElementWrapper from '../ElementWrapper';
import EditorStateMachine, {
  IElement
} from '../../../model/EditorStateMachine';
import { useTranslation } from 'react-i18next';
import PictureModel from '../../../model/picture/PictureModel';
import AntdCustomButton from '../../../../../components/buttons/AntdCustomButton';
import PencilIcon from '../../../components/icons/PencilIcon';

interface FCProps {
  elementData: IElement;
  iframeElement: HTMLIFrameElement;
  pictureId: number;
}

const PictureWrapper: React.FC<FCProps> = observer(
  ({ elementData, iframeElement, pictureId }) => {
    const { t } = useTranslation();
    const isBannerImage = elementData.areaName === 'header-image' || elementData.areaName === 'banner-image';
    return (
      <ElementWrapper
        elementData={elementData}
        iframeElement={iframeElement}
        hoverButtonPosition={isBannerImage ? 'top-right' : 'center'}
        elementId={pictureId}
        hoverButton={
          <div className="flex justify-end">
            <AntdCustomButton
              appearance="important"
              onMouseEnter={() => {
                EditorStateMachine.transition('onButtonHovered', {});
              }}
              onMouseLeave={() => {
                EditorStateMachine.transition('onButtonHoveredEnd', {});
              }}
              className="pointer-events-auto"
              icon={<PencilIcon width={14} height={14} fill="#FFFFFF" />}
              onClick={(e) => {
                e.stopPropagation();
                PictureModel.openPictureEditModal(pictureId);
              }}>
              {t('Edit Image')}
            </AntdCustomButton>
          </div>
        }
      />
    );
  }
);

export default PictureWrapper;
